import React from "react";
import { ReactTyped } from 'react-typed';
import icon from "./icon/I4.png";

const SmartSearchButton = () => {
    return (
        <div className="relative group flex items-center justify-center p-[2.5px] overflow-hidden w-[145px] h-[38px] rounded-full cursor-pointer transition-all duration-500 hover:shadow-[0_0_15px_rgba(66,133,244,0.4)] hover:scale-105 active:scale-95">
            {/* The Animated Border - Thinner and slightly slower for a smoother look */}
            <div className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_0deg,#4285f4,#34a853,#fbbc05,#ea4335,#4285f4)]"></div>

            {/* Inner Content - Clean spacing */}
            <div className="relative flex items-center justify-between w-full h-full bg-white rounded-full z-10 px-1">
                
                {/* Icon Container - Balanced Size */}
                <div className="flex items-center justify-center w-7 h-7 bg-gradient-to-r from-blue-600 to-teal-500 rounded-full shadow-md transform transition-transform duration-300 ease-in-out group-hover:rotate-[10deg]">
                    <img 
                        src={icon} 
                        alt="Search" 
                        className="w-5 h-5 object-contain rounded-full" 
                    />
                </div>

                {/* Typed Text - Clean font and tracking */}
                <div className="flex-1 flex justify-center">
                    <ReactTyped
                        strings={["SMART FILTER", "COLLECTION", "GROHE", "CHROME", "BATH MIXER"]}
                        typeSpeed={80}
                        backSpeed={40}
                        backDelay={1200}
                        loop={true}
                        className="text-gray-900 text-[10px] font-bold tracking-tight pr-3 uppercase"
                    />
                </div>
            </div>

            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default SmartSearchButton;